export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';
//# sourceMappingURL=constants.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/form/constants.js
// module id = 323
// module chunks = 0